import {gql} from "apollo-angular";
import {baseResponseGraphqlField} from "../../../base.graphql";


export const citizenUploadableFormRequestFields = `
id
requestUniqueId
requestCitizen {
  id
  citizenUniqueId
  citizenUserProfile {
    id
    profileUniqueId
    userFirstName
    userLastName
    userEmail
    profilePhone
    profileTitle
    profilePhoto
    profileIsActive
    profileType
  }
  citizenNidaNumber
}
requestCitizenAttachments {
  id
  attachmentUniqueId
  attachmentPath
  formAttachment {
    id
    attachmentUniqueId
    attachmentTitle
    attachmentIsMandatory
  }
}
`


export const CREATE_UPLOADABLE_FORM_REQUEST = gql`
  mutation CreateUploadableFormCitizenRequestMutation($input: UploadableFormCitizenRequestInputObject!) {
    createUploadableFormCitizenRequestMutation(input: $input) {
      ${baseResponseGraphqlField}
      data {
        ${citizenUploadableFormRequestFields}
      }
    }
  }
`

